import React, { useEffect, useRef } from "react";
import moment from "moment";

const iframeStyles = `
  @page { size: 80mm auto; margin: 0mm 5mm 0mm 5mm; }
  @media print {
    body { margin: 0; padding: 0; width: 80mm; }
    .kot-wrapper {
      width: 72mm;
      padding: 2mm 4mm;
      font-family: "Arial", sans-serif;
    }
    .text-center { text-align: center; }
    .text-right { text-align: right; }
    .bold { font-weight: bold; }
    .divider { border-bottom: 2px dashed #000; margin: 8px 0; }
    table { width: 100%; border-collapse: collapse; margin: 10px 0; }
    th, td { padding: 6px 4px; text-align: left; }
    th { border-bottom: 1px solid #000; font-size: 14px; }
    td { font-size: 16px; border-bottom: 1px dotted #ccc; }
    .qty-col { text-align: center; width: 25%; font-size: 18px !important; font-weight: bold; }
    .item-col { width: 75%; }
    .header-text { font-size: 22px; margin: 6px 0; }
    .kot-number { font-size: 24px; font-weight: bold; margin: 6px 0; }
    .info-text { font-size: 14px; margin: 4px 0; }
    .footer-box { border: 2px solid #000; padding: 6px; margin: 10px 0; text-align: center; font-size: 14px; }
  }
`;

const KOTPrintThermal = ({ session, items = [], kotNumber, onPrintComplete, onLog }) => {
  const printRef = useRef();

  useEffect(() => {
    if (!items?.length) return;
    if (!printRef.current) return;

    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    document.body.appendChild(iframe);

    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(
      `<!DOCTYPE html><html><head><title>KOT Print</title><style>${iframeStyles}</style></head><body>${printRef.current.innerHTML}</body></html>`
    );
    iframeDoc.close();

    iframe.contentWindow.onafterprint = () => {
      document.body.removeChild(iframe);
      onPrintComplete?.();
    };

    iframe.contentWindow.focus();
    iframe.contentWindow.print();

    onLog?.();
  }, [items, kotNumber]);

  if (!items?.length) return null;

  return (
    <div style={{ display: "none" }}>
      <div id={`kot-thermal-${kotNumber}`} ref={printRef} className="kot-wrapper">
        <div className="text-center bold header-text">KITCHEN ORDER</div>
        <div className="text-center bold kot-number">KOT #{kotNumber}</div>

        <div className="divider" />

        <div className="info-text">
          <strong>Table / Order:</strong> {session?.label || "—"}
        </div>
        <div className="info-text">
          <strong>Time:</strong> {moment().format("hh:mm A")}
        </div>
        <div className="info-text" style={{ marginBottom: "6px" }}>
          <strong>Date:</strong> {moment().format("MMM DD, YYYY")}
        </div>

        <div className="divider" />

        <table>
          <thead>
            <tr>
              <th className="item-col">ITEM NAME</th>
              <th className="qty-col">QTY</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, idx) => (
              <tr key={idx}>
                <td className="item-col" style={{ fontWeight: 500 }}>
                  {item.name}
                  {item.remark && (
                    <div style={{ fontSize: "12px", fontStyle: "italic", color: "#666", marginTop: "2px" }}>
                      Remark: {item.remark}
                    </div>
                  )}
                </td>
                <td className="qty-col">{item.qty}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="divider" />

        <div className="footer-box">
          <strong>TOTAL ITEMS: {items.length}</strong>
        </div>

        <div className="text-center" style={{ fontSize: "12px", marginTop: "6px" }}>
          Printed: {moment().format("MMM DD, YYYY hh:mm A")}
        </div>
      </div>
    </div>
  );
};

export default KOTPrintThermal;
